import { useContext } from 'react';
import * as R from 'ramda';

import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';

import ElementInfoBox from './ElementInfoBox';
import MoveElementModalContext from './MoveElementModalContext';

import classes from './moveElement.module.css';

const styles = {
  icon: {
    marginRight: '1rem',
  },
  successIcon: {
    fontSize: '56px',
  },
};

interface Props {
  onCloseModal: () => void;
}

const SuccessView = ({ onCloseModal }: Props) => {
  const { element, destinationAssetPath, rootAsset } = useContext(
    MoveElementModalContext,
  );

  const fromAssetDisplay = element.ancestors.map(item => item.name).join(' / ');
  const toAssetDisplay = destinationAssetPath
    .map(item => item.name)
    .join(' / ');
  const toAssetId = R.head(destinationAssetPath)?.id;

  return (
    <div className={classes.successView}>
      <div className={classes.successClose}>
        <IconButton onClick={onCloseModal}>
          <Icon>close</Icon>
        </IconButton>
      </div>
      <div className={classes.successIcon}>
        <Icon style={styles.successIcon} color={colors.brand.green}>
          check_circle
        </Icon>
        <div className={classes.iconBackground} />
      </div>
      <div className={classes.successTitle}>Sub Item Moved Successfully</div>
      <ElementInfoBox
        element={element}
        fromAssetDisplay={fromAssetDisplay}
        fromAssetId={rootAsset.id}
        toAssetDisplay={toAssetDisplay}
        toAssetId={toAssetId}
        pastTense
      />
    </div>
  );
};

export default SuccessView;
